/**
 * Permission enumeration for access control and role-based authorization.
 *
 * This module defines all available permissions in the system, used to control
 * user access to various features and functionalities within the chatbot
 * and use case management platform.
 */

/**
 * Enumeration of all available permissions in the system.
 *
 * Each permission corresponds to a specific feature or action that can be
 * granted to users or roles. Permissions are used throughout the application
 * to enforce access control and authorization checks.
 */
export const PermissionEnum = {
  USE_CHATBOT: 1,

  VIEW_USE_CASES_PUBLISH: 2,
  VIEW_ASSIGNED_USE_CASES_DRAFT: 3,
  VIEW_DG_USE_CASES_DRAFT: 4,

  CREATE_USE_CASE: 6,

  EDIT_ASSIGNED_USE_CASE: 7,
  EDIT_DG_USE_CASE: 8,

  PUBLISH_PRIVATE_USE_CASE: 10,
  PUBLISH_DG_USE_CASE: 11,

  DELETE_PRIVATE_USE_CASE: 13,
  DELETE_DG_USE_CASE: 14,

  EDIT_DG_ASSISTANT_PROMPT: 16,

  DG_DOCUMENT_DESCRIPTIONS: 18,

  EDIT_DG_FUNCTIONS: 24,

  MANAGE_OWN_ACCESS_LIST: 26,
  MANAGE_DG_ACCESS_LIST: 27,

  MANAGE_DG_WHITELISTS: 29,

  VIEW_ANALYTICS: 31,
  CONVERSATION_VIEWER: 32,

  USE_ADMIN_PORTAL: 33,
  VIEW_MULTIPLE_DG: 34,
  EDIT_SYSTEM_SETTINGS: 35,
  VIEW_GLOSSARIES: 36,
  EDIT_GLOSSARIES: 37,
} as const;

export type PermissionEnum = (typeof PermissionEnum)[keyof typeof PermissionEnum];
